import { combineReducers } from "redux";
import AdminReducer from "./AdmininfoReducer";
import usersListReducer from "./UsersListReducer";
import profilesListReducer from "./ProfileListReducer";
import invitationsListReducer from "./InvitationsListReducer";
import servicesListReducer from "./ServicesListReducers";
import DomainsListReducer from "./DomainsListReducer";

export default combineReducers({
    admininfo: AdminReducer,
    UsersList: usersListReducer,
    ProfilesList: profilesListReducer,
    invitations: invitationsListReducer,
    servicesList: servicesListReducer,
    DomainsList: DomainsListReducer
});